import React from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';
import { AppContext } from './AppRouter';
import { isAccessibleRoute, Navigation } from '@constants/Navigation';
import { Spin } from 'antd';

interface Props extends RouteProps {
  component: React.ComponentType;
  path: Navigation;
}

const Unauthorized: React.FC = () => <h1>Not Authorized</h1>;

const Loading: React.FC = () => (
  <div style={{ display: 'grid', width: '100%', height: '100vh', justifyContent: 'center', alignItems: 'center' }}>
    <Spin size="large" />
  </div>
);

const ProtectedRoute: React.FC<Props> = (props) => {
  const { token, user, url } = React.useContext(AppContext);

  if (!token && url === 'default') {
    return <Redirect to={Navigation.Login} />;
  }

  if (!token && url === 'saml') {
    return <Redirect to={Navigation.Login} />;
  }

  if (!user) {
    return <Route {...props} component={Loading} />;
  }

  if (!isAccessibleRoute(user, props.path)) {
    return <Route {...props} component={Unauthorized} />;
  }

  return <Route {...props} />;
};

export default React.memo(ProtectedRoute);
